import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../../pages/landing.css';

const LandingNavbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const isActive = (path: string) => {
    if (path === '/' && location.pathname === '/') return 'active-link';
    return location.pathname.startsWith(path) ? 'active-link' : '';
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="nav-logo" onClick={closeMenu}>
          <i className="fas fa-brain"></i>
          <span>Asknow</span>
        </Link>
        <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          <li><Link to="/" className={location.pathname === '/' ? 'active' : ''} onClick={closeMenu}>Home</Link></li>
          <li><Link to="/features" className={location.pathname === '/features' ? 'active' : ''} onClick={closeMenu}>Features</Link></li>
          <li><Link to="/services" className={location.pathname === '/services' ? 'active' : ''} onClick={closeMenu}>Services</Link></li>
          <li><Link to="/about" className={location.pathname === '/about' ? 'active' : ''} onClick={closeMenu}>About</Link></li>
          <li><Link to="/tech-stack" className={location.pathname === '/tech-stack' ? 'active' : ''} onClick={closeMenu}>Tech Stack</Link></li>
          <li><Link to="/testimonials" className={location.pathname === '/testimonials' ? 'active' : ''} onClick={closeMenu}>Testimonials</Link></li>
          <li><Link to="/case-studies" className={location.pathname === '/case-studies' ? 'active' : ''} onClick={closeMenu}>Case Studies</Link></li>
          <li><Link to="/process" className={location.pathname === '/process' ? 'active' : ''} onClick={closeMenu}>Process</Link></li>
        </ul>
        <div className={`hamburger ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </nav>
  );
};

export default LandingNavbar;
